import { render } from "./commentPage.vue?vue&type=template&id=eb1febb6&scoped=true"
import script from "./commentPage.vue?vue&type=script&lang=js"
export * from "./commentPage.vue?vue&type=script&lang=js"

import "./commentPage.vue?vue&type=style&index=0&id=eb1febb6&lang=css"
import "./commentPage.vue?vue&type=style&index=1&id=eb1febb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1febb6"]])

export default __exports__